import 'moment/locale/pt-br'
import { Table, TableHead, TableRow, TableCell } from '../../shared/components/Table'

import { useNavigate } from 'react-router-dom'
import { formatCpf } from '../../shared/components/helpers/formatCpf'
import { formatMoney } from '../../shared/components/helpers/formatMoney'
import { formatRecurrence } from '../../shared/components/helpers/formatRecurrence'
import { formatRecurrenceQuantity } from '../../shared/components/helpers/formatRecurrenceQuantity'
import { ResponsiveTableWrapper } from './LeadsList.styles'
import { formatLeadStatus } from '../../shared/components/helpers/formatLeadStatus'
import { formatCpfCnpj } from '../../shared/components/helpers/formatCpfCnpj'

import moment from 'moment'

import { StatusLabel } from '@creditas-ui/react'

const LeadsList = ({ leads }) => {
  moment.locale('pt-br')

  let navigate = useNavigate()

  function handleClick(id) {
    navigate(`/lead/${id}`)
  }

  return (
    <ResponsiveTableWrapper>
      <Table>
        <TableHead
          headings={[
            ' Nome ',
            ' CPF ',
            ' Total do Pacote ',
            ' Imobiliária ',
            ' Criação do Lead ',
            ' Entrada ',
            ' Status ',
            ' Consultor ',
            ' Recorrência ',
            ' Reincidências ',
          ]}
        />
        <tbody>
          {leads?.map((leadItem) => (
            <TableRow id={leadItem.id} key={leadItem.id} onClick={() => handleClick(leadItem.id)}>
              <TableCell>{leadItem.lead?.fullName}</TableCell>
              <TableCell>{formatCpf(leadItem.lead?.cpf)}</TableCell>
              <TableCell>{formatMoney(leadItem?.rent)}</TableCell>
              <TableCell> {formatCpfCnpj(leadItem.realEstateCnpj)}</TableCell>
              <TableCell>
                {moment(leadItem?.leadCreation, 'DD-MM-YYYY HH:mm').format('DD/MM/YYYY HH:mm')}
              </TableCell>
              <TableCell>
                {moment(leadItem?.greyzoneEntry, 'DD-MM-YYYY HH:mm').format('DD/MM/YYYY HH:mm')}
              </TableCell>
              <TableCell>
                <StatusLabel variant={leadItem.hasActiveContract ? 'warning' : 'neutral'} />
                {formatLeadStatus(leadItem.status)}
              </TableCell>
              <TableCell>{leadItem.lastConsultant}</TableCell>
              <TableCell>{formatRecurrence(leadItem.isRecurrence)}</TableCell>
              <TableCell> {formatRecurrenceQuantity(leadItem.recurrenceQuantity)}</TableCell>
            </TableRow>
          ))}
        </tbody>
      </Table>
    </ResponsiveTableWrapper>
  )
}

export { LeadsList }
